<template>
  <v-breadcrumbs :items="breadCrumbs">
    <template #item="{ item }">
      <v-breadcrumbs-item
        :to="item.to"
        class="text-subtitle-2 crumb-item"
        :disabled="item.disabled"
        exact
      >
        {{ item.text }}
      </v-breadcrumbs-item>
    </template>
    <template #divider>
      <div class="flex items-center">
        <v-img :src="ChevronForwardIcon" width="16" alt="chevron-forward" />
      </div>
    </template>
  </v-breadcrumbs>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router/composables';
import ChevronForwardIcon from '@/assets/img/icons/arrow/chevron-forward.svg';

export default defineComponent({
  name: 'CfsBreadcrumbs',
  setup() {
    const route = useRoute();

    const breadCrumbs = computed(() => {
      if (typeof route.meta?.breadCrumbs === 'function') {
        return route.meta?.breadCrumbs(route);
      }
      return route.meta?.breadCrumbs || [];
    });

    return { breadCrumbs, ChevronForwardIcon };
  },
});
</script>

<style lang="scss">
.v-breadcrumbs {
  padding: 0 0 0.25rem 0 !important;

  li:last-of-type .v-breadcrumbs__item {
    color: var(--v-anchor-base) !important;
  }

  &__item {
    color: #4e4b66 !important;
    &:hover {
      color: var(--v-anchor-base) !important;
    }
  }
}
</style>
